import { useEffect, useState } from 'react';

import { api, type Adatminoseg as AdatminosegAdat } from '../api.ts';
import { ft } from '../formazas.ts';

/**
 * Adatminőség. (Megbízás 2.0 / 5.9)
 *
 * Hét ellenőrzés a törzsön. Mindegyiknél darabszám, egy mondat arról, hogy
 * miért baj, és egy gomb, ami a megfelelő szűrt nézetre visz.
 *
 * A **javítandó** és a **csak megjegyzendő** tételek külön vannak. Ez azért
 * fontos, mert a 441 étteremből sok a hiányos adat, de nem mind hiba: aki
 * csak gyűjtéses, annak nem kell ár; aki nem számláz, annak nem kell adószám.
 * Ha mindet pirosnak látnád, egyiket sem néznéd meg.
 */
export function Adatminoseg({
  onUgras,
}: {
  onUgras: (kepernyo: string, opciok?: { szuro?: string }) => void;
}) {
  const [adat, setAdat] = useState<AdatminosegAdat | null>(null);
  const [hiba, setHiba] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<AdatminosegAdat>('/api/attekintes/adatminoseg')
      .then(setAdat)
      .catch((h: Error) => setHiba(h.message));
  }, []);

  if (hiba) return <div className="uzenet bad">{hiba}</div>;
  if (!adat) return <div className="uzenet">Betöltés…</div>;

  const javitando = adat.ellenorzesek.filter((e) => e.fajta === 'javitando');
  const megjegyzendo = adat.ellenorzesek.filter((e) => e.fajta === 'megjegyzendo');
  const javitandoDb = javitando.reduce((a, e) => a + e.darab, 0);

  return (
    <>
      <div className="dayhead">
        <span style={{ fontSize: 15, fontWeight: 600 }}>Adatminőség</span>
        <div className="stats">
          <div>
            Aktív étterem
            <strong>{ft(adat.ettermek)}</strong>
          </div>
          <div>
            Javítandó
            <strong>{ft(javitandoDb)}</strong>
          </div>
        </div>
      </div>

      <h3 className="szakaszcim">
        Javítandó
        <span className="halvany">valódi hiba, ki kell javítani</span>
      </h3>
      <div className="minoseg">
        {javitando.map((e) => (
          <Ellenorzes key={e.kulcs} e={e} onUgras={onUgras} />
        ))}
      </div>

      <h3 className="szakaszcim">
        Megjegyzendő
        <span className="halvany">nem hiba, csak tudni kell róla</span>
      </h3>
      <div className="minoseg">
        {megjegyzendo.map((e) => (
          <Ellenorzes key={e.kulcs} e={e} onUgras={onUgras} />
        ))}
      </div>
    </>
  );
}

function Ellenorzes({
  e,
  onUgras,
}: {
  e: AdatminosegAdat['ellenorzesek'][number];
  onUgras: (kepernyo: string, opciok?: { szuro?: string }) => void;
}) {
  const rendben = e.darab === 0;
  return (
    <div className={`mcard${rendben ? ' rendben' : e.fajta === 'javitando' ? ' javitando' : ''}`}>
      <div className="mszam">{ft(e.darab)}</div>
      <div className="mszoveg">
        <b>{e.cim}</b>
        <span>{rendben ? 'Nincs ilyen tétel — ez rendben van.' : e.magyarazat}</span>
      </div>
      {e.ugras && !rendben && (
        <button className="btn sm" onClick={() => onUgras(e.ugras!.kepernyo, { szuro: e.ugras!.szuro })}>
          {e.gomb}
        </button>
      )}
    </div>
  );
}
